// Never let a draft card pool be replaced by an empty list when a populated
// source exists. Prefers the freshest populated source (incoming server data),
// then the current in-memory pool, then a durable fallback (e.g. the saved
// blob). The same "never empty over data" guard the authoritative client mirror
// uses. A transient empty fetch must never strand the player on an empty pool.
export function resolveDraftPool({ incoming, current, fallback } = {}) {
  const populated = (v) => (Array.isArray(v) && v.length ? v : null);
  return populated(incoming) || populated(current) || populated(fallback) || [];
}
